import { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";

export default function ListDojos(props) {
  const ls = require("localstorage-ttl");
  const [data, setData] = useState([]);

  useEffect(() => {
    LoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoadData = () => {
    const dataCache = JSON.parse(ls.get("dojos"));

    let dojos = [];
    for (let i = 0; i < dataCache.length; i++) {
      const u = dataCache[i];

      const instuctors = u.attributes.instructor?.data;
      let instuctorsData = [];
      if (instuctors && instuctors.length > 0) {
        for (let s = 0; s < instuctors.length; s++) {
          instuctorsData.push(instuctors[s].attributes.docNumber);
        }
      }

      let x = {
        id: u.id,
        nombre: u.attributes.name,
        direccion: u.attributes.address,
        provincia: u.attributes.province,
        telefono: u.attributes.phone,
        email: u.attributes.email,
        webpage: u.attributes.webpage,
        facebook: u.attributes.facebook,
        instagram: u.attributes.instagram,
        startDate: u.attributes.startDate,
        endDate: u.attributes.endDate,
        responsable: u.attributes.responsible?.data?.id
          ? u.attributes.responsible?.data?.attributes?.lastname +
            " " +
            u.attributes.responsible?.data?.attributes?.name
          : "",
        asociacionId: u.attributes.asociated?.data?.id,
        asociacion: u.attributes.asociated?.data?.attributes?.name,
        instructors: instuctorsData.join(),
      };
      dojos.push(x);
    }
    setData(dojos);
  };

  // const GetData = () => {
  //   axios
  //     .get(
  //       `${API_URL}/dojos?populate=*&pagination[pageSize]=1000`,
  //       headerRequest
  //     )
  //     .then((d) => {
  //       let dojos = [];
  //       for (let i = 0; i < d.data.data.length; i++) {
  //         const u = d.data.data[i];

  //         const instuctors = u.attributes.instructor?.data;
  //         let instuctorsData = [];
  //         if (instuctors && instuctors.length > 0) {
  //           for (let s = 0; s < instuctors.length; s++) {
  //             instuctorsData.push(instuctors[s].attributes.docNumber);
  //           }
  //         }

  //         let x = {
  //           id: u.id,
  //           nombre: u.attributes.name,
  //           direccion: u.attributes.address,
  //           provincia: u.attributes.province,
  //           telefono: u.attributes.phone,
  //           email: u.attributes.email,
  //           webpage: u.attributes.webpage,
  //           facebook: u.attributes.facebook,
  //           instagram: u.attributes.instagram,
  //           startDate: u.attributes.startDate,
  //           endDate: u.attributes.endDate,
  //           responsable: u.attributes.responsible?.data?.id
  //             ? u.attributes.responsible?.data?.attributes?.lastname +
  //               " " +
  //               u.attributes.responsible?.data?.attributes?.name
  //             : "",
  //           asociacionId: u.attributes.asociated?.data?.id,
  //           asociacion: u.attributes.asociated?.data?.attributes?.name,
  //           instructors: instuctorsData.join(),
  //         };
  //         dojos.push(x);
  //       }
  //       console.log({ dojos });
  //       setData(dojos);
  //     });
  // };

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>EXPORTAR DOJOS</h4>
      <CSVLink
        data={data}
        filename={"faa-dojos.csv"}
        className="btn btn-success btn-sm"
      >
        DESCARGAR
      </CSVLink>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>ID</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Provincia</th>
            <th>Teléfono</th>
            <th>Email</th>
            <th>Responsable</th>
          </tr>
        </thead>
        <tbody>
          {!data || data.length < 1 ? (
            <tr>
              <td colSpan="8" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            data.map((u, index) => (
              <tr key={index}>
                <td align="center">{++index}</td>
                <td align="center">{u.id}</td>
                <td align="left">{u.nombre}</td>
                <td align="left">{u.direccion}</td>
                <td align="left">{u.provincia}</td>
                <td align="left">{u.telefono}</td>
                <td align="left">{u.email}</td>
                <td align="left">{u.responsable}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
}
